import { render, staticRenderFns } from "./SysCustomFormModal.vue?vue&type=template&id=b8bcbc34"
import script from "./SysCustomFormModal.vue?vue&type=script&lang=js"
export * from "./SysCustomFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports